import AnalyticsClient from '@st-graphics/backend/client/analytics'

export default {
  install (Vue) {
    Vue.prototype.$analytics = {
      clients: {},
      getClient (projectId, debug) {
        this.clients[projectId] = this.clients[projectId] ||
                                  new AnalyticsClient(projectId, debug)
        return this.clients[projectId]
      }
    }
  }
}
